import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { api } from "../../api";
import { imagePath } from "../../utils/assetUtils";
import { decimalTo } from "../../utils/utils";
import DashBoardNum from "../Dashboard/dashboardData/dashBoardNum/DashBoardNum";
import DevcoFinancialTable from "./DevcoFinancialTable";
import DevcoSalesTable from "./DevcoSalesTable";
import DevcoProductsTable from "./DevcoProductsTable";

// Icons
const MoneyIcon = imagePath("bx-money.svg");

function DevcoDashboard() {
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();

  const [devcoData, setDevcoData] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDevcoData = async () => {
      setLoading(true);
      setError(null);

      try {
        const balanceResponse = await api.devco.getDevcoBalance({}, token);

        if (balanceResponse?.success && balanceResponse.data?.CONTENT) {
          setDevcoData(balanceResponse.data.CONTENT);
        } else {
          setError("Failed to load Devco balance data");
        }
      } catch (error) {
        console.error("Error fetching Devco data:", error);
        setError("Failed to load Devco data");
      } finally {
        setLoading(false);
      }
    };

    if (user && token) {
      fetchDevcoData();
    }
  }, [token, user]);

  if (!user || !token) {
    navigate("/login");
    return null;
  }

  if (loading) {
    return (
      <div>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none",
            zIndex: 999,
          }}
        >
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="box-row">
            <h1 className="sec-header mt-3">DEVCO DASHBOARD</h1>

            {/* Stats Cards Row */}
            <div className="row dashboard-row">
              <DashBoardNum
                text={`Devco Balance${
                  devcoData.RESELLER_Currency
                    ? ` (${devcoData.RESELLER_Currency})`
                    : ""
                }`}
                image={MoneyIcon}
                count={
                  devcoData.RESELLER_Balance
                    ? decimalTo(devcoData.RESELLER_Balance).toFixed(2)
                    : "0.00"
                }
              />
            </div>

            <DevcoFinancialTable />
            <DevcoSalesTable />
            <DevcoProductsTable />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DevcoDashboard;
